var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4283 10.4869L9.26628 8.32483C9.92153 7.46704 10.2809 6.4266 10.281 5.32869C10.281 4.00562 9.76575 2.76164 8.83004 1.82609C7.89449 0.890544 6.65068 0.375244 5.32743 0.375244C4.00435 0.375244 2.76038 0.890544 1.82483 1.82609C-0.106486 3.75757 -0.106486 6.90015 1.82483 8.8313C2.76038 9.76701 4.00435 10.2823 5.32743 10.2823C6.42533 10.2822 7.46578 9.92279 8.32357 9.26754L10.4856 11.4296C10.6157 11.5598 10.7864 11.6249 10.957 11.6249C11.1276 11.6249 11.2983 11.5598 11.4283 11.4296C11.6888 11.1694 11.6888 10.7472 11.4283 10.4869ZM2.76754 7.88859C1.35608 6.47713 1.35624 4.18042 2.76754 2.7688C3.45129 2.08521 4.36047 1.70858 5.32743 1.70858C6.29456 1.70858 7.20357 2.08521 7.88733 2.7688C8.57109 3.45256 8.94771 4.36174 8.94771 5.32869C8.94771 6.29582 8.57109 7.20483 7.88733 7.88859C7.20357 8.57235 6.29456 8.94897 5.32743 8.94897C4.36047 8.94897 3.45129 8.57235 2.76754 7.88859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/searchWhite.80a2925b36d1a40fc710988c380667f4.svg";
export { ForwardRef as ReactComponent };